/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { clientSideOnly } from '@atlassian/jira-common-client-side-only/src/index.tsx';

import StatuspageDetailsPageQuery$parameters from './src/ui/__generated__/StatuspageDetailsPageQuery.graphql';
import StatuspageDetailsPageDraftQuery$parameters from './src/ui/__generated__/StatuspageDetailsPageDraftQuery.graphql';

export const communicationsStatusPageDetailsEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		clientSideOnly(
			import(
				/* webpackChunkName: "async-communications-status-page-details-entrypoint" */ './src/ui/StatuspageDetailsPage'
			).then((module) => module.StatuspageDetailsPage),
		),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => {
		return {
			queries: {
				StatuspageDetailsPageQuery: {
					parameters: StatuspageDetailsPageQuery$parameters,
					variables: {
						pageId: context.match.params.pageId || '',
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
				StatuspageDetailsPageDraftQuery: {
					parameters: StatuspageDetailsPageDraftQuery$parameters,
					variables: {
						pageId: context.match.params.pageId || '',
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
